module.exports = __webpack_public_path__ + "5b761f2d1e4259ea6ac7ab3ebf7f3c49.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Light.ttf
// module id = 692
// module chunks = 0